import {ChangeDetectorRef, Component} from '@angular/core';
import {
  AlertController, App, IonicPage, LoadingController, MenuController, NavController, NavParams, Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';
import {FileTransfer,FileUploadOptions, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";
import {Media, MediaObject} from "@ionic-native/media";
import { FileChooser } from '@ionic-native/file-chooser';
import { FileOpener } from '@ionic-native/file-opener';
import {AndroidPermissions} from "@ionic-native/android-permissions";


@Component({
  selector: 'page-data-call-log',
  templateUrl: 'data-call-log.html',
})
export class DataCallLogPage {

  DataId:any;
  EnquiryData:any;
  UserName:any;
  FUserId:any;
  FUserTypeId:any;
  LogsData:any;
  datanotfound:any;
  FWebEnquiryId:any;


  CallStatus:any;
  CallStatusItem:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public alertCtrl: AlertController,
              public cdRef:ChangeDetectorRef,
              public viewCtrl: ViewController,
              public fileTransfer:FileTransfer,
              public file:File,
              public loadingctrl:LoadingController,
              private media: Media,
              private filechooser:FileChooser,
              private fileOpener:FileOpener,
              private androidPermissions: AndroidPermissions

  ) {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {
        if(navParams.get('Tab')==1){
          this.EnquiryData = navParams.get('data');
          this.DataId=this.EnquiryData.DataId;
          this.FWebEnquiryId=this.EnquiryData.Id;
        }
        else if(navParams.get('Tab')==2){
          this.EnquiryData = navParams.get('data');
          this.DataId=this.EnquiryData.DataId;
          this.FWebEnquiryId=this.EnquiryData.FWebEnquiryId;
        }
        else if(navParams.get('Tab')==3){
          this.EnquiryData = navParams.get('data');
          this.DataId=this.EnquiryData.FDataId;
          this.FWebEnquiryId=this.EnquiryData.FWebEnquiryId;
        }
        else if(navParams.get('Tab')==4){
          this.EnquiryData = navParams.get('data');
          this.DataId=this.EnquiryData.FDataId;
          this.FWebEnquiryId=this.EnquiryData.FWebEnquiryId;
        }
        else if(navParams.get('Tab')==5)
        {
          this.DataId=navParams.get('FDataId');
          this.FWebEnquiryId=navParams.get('FWebEnquiryId');
        }

        console.log("213",this.EnquiryData);

        this.UserName=values[1]['Name'];
        this.FUserId = values[0]['FUserId'];
        this.FUserTypeId = values[0]['FUserTypeId'];
        console.log(this.FUserId);
        this.loadlogs(this.FWebEnquiryId);
      });
    });
  }

  AddCallStatus(item){

   this.CallStatus=null;
   this.CallStatusItem=null;

   this.service.httpcall('web_service/get_master_call_log_status?').subscribe(data => {

      console.log("get_master_call_log_status",data);

      if(data != ""){

        this.CallStatus=data;

        console.log(this.CallStatus);

        let myAlert = this.alertCtrl.create({
          title: 'Set Call Status',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data," ",item.Id);

                  this.service.httpcall('web_service/add_callStatus_On_webEnquiryId?FCallLogId='+item.Id+'&FCallStatusId=' + data+'&FUserId='+this.FUserId).subscribe(data => {
                  console.log(data);
                  if(data['response']=="success"){
                    this.presentToast(data['success_message']);
                  }else{
                    this.presentToast(data['error_description']);
                  }
                }
                ,(error2 => {
                  this.presentToast("Timeout!");
                }))

              }
            }
          ]
        });

        for(var i = 0; i < this.CallStatus.length; i++) {
          this.CallStatusItem=this.CallStatus[i];
          var edata=this.CallStatusItem.Name;
          console.log(edata);
          myAlert.addInput({
            type:'radio',
            label: edata,
            value:  this.CallStatusItem.Id
          })
        }

        myAlert.present();
      }else{
        this.presentToast(data['error_description']);
      }
    },(error2 => {
      this.presentToast("Timeout!");
    }))
  }

  presentToast(msg){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DataCallLogPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  loadlogs(FWebEnquiryId){
    this.LogsData=[];
    this.LogsData=null;
    this.datanotfound=null;
    this.service.httpcall('web_service/get_enquiry_call_logs?FWebEnquiryId='+FWebEnquiryId).subscribe(data => {
      console.log(data);
      if(data['response']=="success"){
        this.LogsData=data['data'];
        this.datanotfound=null;
      }else{
        this.datanotfound=data['error_description'];
      }

    })
  }




  getCallFromFolder(FcallId,fileaname)
  {
    let filedir = this.file.externalRootDirectory+'ApplusCallRecording/Outgoing/'+fileaname;


    this.file.resolveLocalFilesystemUrl(filedir).then((entry: any) => {
      entry.file((file1) => {
       console.log(file1);
        //alert('file1'+JSON.stringify(file1));
         const reader = new FileReader();


         reader.onloadend = () => {
           const formData = new FormData();
           const imgBlob = new Blob([reader.result], {type: file1.type});
           formData.append('uploadedfile', imgBlob, fileaname);
           formData.append('FileName', fileaname);
            this.upload_call_logs(formData,fileaname);
         };
       // this.save_event(formData,fileaname);
         reader.readAsArrayBuffer(file1);
      })
    }).catch((error) => {
      console.log('file error', error);
      const formData = new FormData();
      const imgBlob = new Blob();
      formData.append('uploadedfile', imgBlob, '');
      formData.append('FileName', fileaname);
      let toast= this.toastCtrl.create({
        message:'No Call Recorded...',
        duration:1000
      });

      toast.present();
    })
  }


  upload_call_logs(formData,fileaname)
  {

    let loading=this.loadingCtrl.create({
      content:'Uploading' + fileaname+ ".mp3 to server ...",
    });

    loading.present();

    console.log("event calling")

    this.service.httppostFormcall('web_service/UpdateCallRecord',formData).subscribe(data => {
        loading.dismiss();
        console.log("add_document_files", data);
      this.loadlogs(this.EnquiryData);
        if (data['status']=="sucess")
        {
          let toast= this.toastCtrl.create({
            message:'File Uploaded Sucessfully...',
            duration:1000
          });

          toast.present();
        }
      else
      {
        let toast= this.toastCtrl.create({
          message:'Error Uploading File...',
          duration:1000
        });

        toast.present();
      }
    });

  }

  playaudio(fileurl,filename)
  {

    /*Create Folder*/
    this.file.checkDir(this.file.externalRootDirectory, 'ApplusDownload').then(response => {
      console.log('Directory exists'+response);
    }).catch(err => {
      console.log('Directory doesn\'t exist'+JSON.stringify(err));
      this.file.createDir(this.file.externalRootDirectory, 'ApplusDownload', false).then(response => {
        console.log('Directory create'+response);
      }).catch(err => {
        console.log('Directory no create'+JSON.stringify(err));
      });
    });

    /*Create Folder*/

    let path=this.file.externalRootDirectory+'ApplusDownload/'+filename

    console.log(path);

    this.file.resolveLocalFilesystemUrl(path).then((entry: any) => {
      entry.file((file1) =>
      {
        this.openAudioFromStorage(path);
        console.log(file1);
      })
    }).catch((error) =>
    {
      console.log(error);
      this.downloadCall(fileurl,filename,path);
    });

    //this.openAudioFromStorage('');


  }

  downloadCall(fileurl,filename,path)
  {

    this.file.checkDir(this.file.externalRootDirectory, 'ApplusDownload').then(response => {
      console.log('Directory exists'+response);
    }).catch(err => {
      console.log('Directory doesn\'t exist'+JSON.stringify(err));
      this.file.createDir(this.file.externalRootDirectory, 'ApplusDownload', false).then(response => {
        console.log('Directory create'+response);
      }).catch(err => {
        console.log('Directory no create'+JSON.stringify(err));
      });
    });

    let loading=this.loadingCtrl.create({
      content:'Downloading Recording Please Wait...'
    });

    loading.present();

    setTimeout(()=>{
      loading.dismiss();
    },10000)

    const fileTransfer: FileTransferObject = this.fileTransfer.create();

    fileTransfer.download(fileurl, this.file.externalRootDirectory+'ApplusDownload/'+filename).then((entry) => {
      console.log('download complete: ' + entry.toURL());
      loading.dismiss();
      this.openAudioFromStorage(path);
    }, (err) => {
      // handle error
      loading.dismiss();
      console.log('Error',err);
    });
  }

  openAudioFromStorage(path)
  {

    this.fileOpener.open(path, 'audio/mpeg')
        .then(() => console.log('File is opened'))
        .catch(e => console.log('Error opening file', e));
  }

  checkPermission()
  {
    console.log("Check Permission");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(result => {
          //this.hasPermission = result.hasPermission;
          console.log('Has permission?', result['hasPermission']);
          if (result['hasPermission']) {
            console.log("Has Permission");
          } else {
            console.log("Deny Permission");
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
              console.log(result_data);
              if (result_data['hasPermission']) {
                console.log('Storage allow ', result_data['hasPermission']);
              } else {
                console.log('Storage deny ', result_data['hasPermission']);
              }
            }).catch((err) => {
              console.log("catch loop",JSON.stringify(err));
            });
          }
        },
        err => {
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
            console.log(result_data);
            console.log('error Has permission?', result_data['hasPermission']);
            if (result_data['hasPermission']) {
              console.log('err Storage allow ', result_data['hasPermission']);
            } else {
              console.log('err Storage deny ', result_data['hasPermission']);
            }
          }).catch((err) => {
            console.log(JSON.stringify(err));
          });
        });

  }


}



// WEBPACK FOOTER //
// ./src/pages/data-call-log/data-call-log.ts